var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJewels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4699 20.24H30.5299C30.1099 20.24 29.6999 20.41 29.3999 20.7L12.4399 37.49C11.8899 38.03 11.8499 38.91 12.3399 39.5L48.8499 83.24C49.4399 83.95 50.5399 83.95 51.1299 83.24L87.6499 39.5C88.1399 38.91 88.0999 38.03 87.5499 37.49L70.5999 20.7C70.2999 20.4 69.8999 20.24 69.4699 20.24Z",
    fill: "#F9907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.53 38.45H11.47L29.87 20.24H70.13L88.53 38.45Z",
    fill: "#F9907B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.53 38.45H11.47L50 84.6L88.53 38.45Z",
    fill: "#C75E5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 38.45H32.7L50 84.6L67.3 38.45Z",
    fill: "#F9907B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 38.45H32.7L50 20.24L67.3 38.45Z",
    fill: "#FAC1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewels);
export default __webpack_public_path__ + "static/media/Jewels.b10528a533c31feebff0ae5777730480.svg";
export { ForwardRef as ReactComponent };